import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { IDatesSectionProps } from './types';
import { DATES_TITLE } from '../../constants';
import { DatesHOC } from '../../hocs/DatesHOC/DatesHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function DatesSection ({
}: IDatesSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--dates';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.DATES_TIME} />
            <SettingsSection
                className={className}
                title={DATES_TITLE}
            >
                <DatesHOC boardId={boardId} />
            </SettingsSection>
        </>
    );
};
